import { render, staticRenderFns } from "./ChangeKennelOwnersForm2.vue?vue&type=template&id=b75a70cc"
import script from "./ChangeKennelOwnersForm2.vue?vue&type=script&lang=ts"
export * from "./ChangeKennelOwnersForm2.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports